import { useState, useEffect } from "react";

// next.js components
import Image from "next/image";
import Link from "next/link";

// react-copy-to-clipboard components
import { CopyToClipboard } from "react-copy-to-clipboard";

// @material-tailwind/react components
import {
  Tabs,
  TabsHeader,
  Tab,
  Typography,
  Button,
  Tooltip,
} from "@material-tailwind/react";

export default function Header() {
  const [version, setVersion] = useState("CPP");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }, [copied]);

  return (
    <div className="h-screen min-h-screen bg-[url('/img/bg-header.jpg')] bg-cover bg-center bg-no-repeat">
      <div className="relative z-50 h-fit py-20 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center justify-between">
            <div className="mt-48 w-full px-4 md:w-8/12 lg:mt-4 lg:w-5/12">
              <div className="w-full max-w-full sm:my-auto md:w-5/6 md:flex-none lg:w-1/2">
                <Tabs value="CPP" className="mb-6">
                  <TabsHeader
                    className="h-10 w-auto rounded-full border border-white/80 bg-white/80 shadow-2xl shadow-blue-gray-500/40 backdrop-blur-2xl backdrop-saturate-200"
                    indicatorProps={{
                      className: "rounded-full",
                    }}
                  >
                    <Tab
                      value="CPP"
                      className="p-0 font-normal text-[#1A237E]"
                      onClick={() => setVersion("CPP")}
                    >
                      <i className="fa-solid fa-code-branch" />
                      &nbsp;CPP
                    </Tab>
                    <Tab
                      value="Python"
                      className="p-0 font-normal text-[#1A237E]"
                      onClick={() => setVersion("Python")}
                    >
                      <i className="fab fa-python" />
                      &nbsp;Python
                    </Tab>
                    <Tab
                      value="Java"
                      className="p-0 font-normal text-[#1A237E]"
                      onClick={() => setVersion("Java")}
                    >
                      <i className="fab fa-java" />
                      &nbsp;Java
                    </Tab>
                  </TabsHeader>
                </Tabs>
              </div>
              <Typography
                variant="h1"
                className="mb-2 font-black tracking-normal text-[#ffffff]"
              >
                Code Crush
              </Typography>
              <Typography className="mb-6 text-lg font-light text-[#ffffff] lg:pr-12">
                Code Crush enhances your proficiency in DSA concepts This
                platform design ensures a streamlined learning experience
                Utilize Code Crush to confidently excel in coding interviews and
                secure your desired placements
              </Typography> 
              <div className="flex flex-col-reverse gap-2 lg:flex-row">
                <Link
                  href={
                    version === "CPP"
                      ? "/test"
                      : "/docs/html/installation"
                  }
                >
                  <Button variant="gradient" className="h-full w-full">
                    Get Started
                  </Button>
                </Link>
                <div className="flex rounded-lg border border-white/80 bg-white/80 py-2.5 px-5 text-[#1A237E] shadow-2xl shadow-blue-gray-500/20 backdrop-blur-2xl backdrop-saturate-200">
                  <CopyToClipboard
                    text={version}
                    onCopy={() => setCopied(true)}
                  >
                    <p className="mb-0 flex w-full items-center justify-between font-normal">
                      {version}
                      <Tooltip
                        content={copied ? "Copied" : "Copy"}
                        interactive={false}
                      >
                        <i
                          className={`${
                            copied ? "fas" : "far"
                          } fa-copy ml-4 cursor-pointer text-sm`}
                        />
                      </Tooltip>
                    </p>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
